import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwhthsaaew: FaireProductEntity = {
  token: "p_uwhthsaaew",
  type: "product",
  name: "22L Large Capacity Reusable Canvas Tote Bag for Women Men",
  brandToken: "b_785s5jxz4n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/35b46b5fb4304a553174b724f281d4e9806edd80125e2cfd955f877ee68b6fc4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4124ce0204997aa59c49508ec2fac7fe83918d7a08cb3de5de33204153c10e14.jpeg",
    "https://cdn.faire.com/fastly/4d970dd516b9954c8d634a36f925b29779645873593811681dbfa5747a166124.jpeg",
    "https://cdn.faire.com/fastly/207afcee3cf3fd364ed2f07fa6b1d822171035a0bbece52a297fe2a2daa17669.jpeg",
    "https://cdn.faire.com/fastly/5bfbe94b684e006a64c9cdc7c1fbdf31d6a986b240f2b4e7e166214f2210a9a6.jpeg",
    "https://cdn.faire.com/fastly/6b18cbc040bdac39022f3d82ac2837e2a63b3ab6bfb165e35ce0709379376180.jpeg",
    "https://cdn.faire.com/fastly/785f2d09975e74f565a524557b3375cb2b0a553a4f96cb35b6caf4d381594492.jpeg",
    "https://cdn.faire.com/fastly/ac6b41913a5ae9444ce82d34d4d916cf3a5be6cb608614f387d241ff7dc7a746.jpeg",
    "https://cdn.faire.com/fastly/f5086ff0c31e0e626ef01dfcd9f7d56145cfb4c9830edb379e7959775043c502.jpeg",
    "https://cdn.faire.com/fastly/5d2570cf8fc95c5e17d4abb44daed171367469702bba1ae2b47a0640597f7ccf.jpeg",
    "https://cdn.faire.com/fastly/cd570bb727c88f73bc269de013ff502693812452cad677a918cf393d2c014975.jpeg",
    "https://cdn.faire.com/fastly/c222556dbaac84023d7a4568300d83574a4e7949bcaefaee15fdde76074ef6c7.jpeg",
    "https://cdn.faire.com/fastly/f5772dcec248c5e661423a62b9f33fccb45640135d406e9d897c0b4108f3eedb.jpeg",
    "https://cdn.faire.com/fastly/c3b42365746004d7694c7372f09391400424106272b7fe97d313d09ac5e9ec6c.jpeg",
    "https://cdn.faire.com/fastly/38b7acf2a08beb2eef9a6b7259785ecc6ea09aa658e1e2c9a4e779b324776fc6.jpeg",
  ],
  priceDollars: 23.27,
  description:
    "Generous Dimensions: Measuring 55cm/21.6 inches in width, 34cm/13.4 inches in height, and with a base depth of 17cm/6.7 inches (top opening depth 11cm/4.3 inches), it offers ample space for carrying a variety of items. The handle height is 29cm/11.4 inches for easy shoulder - carrying.\nSimple & Stylish Design: The sleek black color and minimalist design make it a versatile accessory suitable for different occasions, from shopping to work or travel.\nDurable Material: Likely made from sturdy fabric, ensuring it can withstand regular use and hold heavy loads without easily wearing out.\nPractical Structure: It has a large main compartment that can accommodate essentials like books, a laptop, clothes, or groceries.",
  tags: [],
  msrpDollars: 46.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:42.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
